import { useUserAssignments } from "@/store/selectors/assignmentSelectors";
import { useUserIncompleteAssignments } from "@/store/selectors/assignmentSelectors";
import { CardProps, Stack } from "@mantine/core";
import { useMemo } from "react";
import { Text } from "../ui/Text";
import { UserProfileCard } from "./UserProfileCard";
import { UserProfileNoResults } from "./UserProfileNoResults";

export function UserProfileAssignments(props: { showCompleted?: boolean }) {
  const { showCompleted } = props;
  const userAssignments = useUserAssignments();
  const userIncompleteAssignments = useUserIncompleteAssignments();
  const userCompleteAssignments = useMemo(() => {
    return Object.values(userAssignments).filter((assignment) => {
      return !userIncompleteAssignments.find(
        (incompleteAssignment) => incompleteAssignment.id === assignment.id,
      );
    });
  }, [userAssignments, userIncompleteAssignments]);

  const assignmentsToShow = useMemo(() => {
    return showCompleted ? userCompleteAssignments : userIncompleteAssignments;
  }, [showCompleted, userCompleteAssignments, userIncompleteAssignments]);

  if (!assignmentsToShow.length) {
    return (
      <UserProfileNoResults
        title={
          showCompleted
            ? "You haven't completed any assignments yet."
            : "You don't have any assignments."
        }
        description={
          showCompleted
            ? "You haven't completed any assignments yet."
            : "You don't have any assignments."
        }
      />
    );
  }

  return (
    <Stack maw={700}>
      {assignmentsToShow.map((assignment) => (
        <UserProfileAssignmentCard
          key={assignment.id}
          assignment={assignment}
          isCompleted={
            !!userCompleteAssignments.find(
              (completeAssignment) => completeAssignment.id === assignment.id,
            )
          }
        />
      ))}
    </Stack>
  );
}

export function UserProfileAssignmentCard(props: {
  assignment: any;
  cardProps?: CardProps;
  isCompleted?: boolean;
}) {
  const { assignment, isCompleted } = props;
  return (
    <UserProfileCard
      href={`/assignments/${assignment.id}`}
      badge={{
        color: isCompleted ? "green" : "primary",
        label: isCompleted ? "Completed" : "In Progress",
      }}
    >
      <Text titleStyle="h4">{assignment.title}</Text>
      <Text lineClamp={3} size="sm">
        {assignment.instructions}
      </Text>
    </UserProfileCard>
  );
}
